import { ListItem, ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { PowerSettingsNew } from "@material-ui/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { withFirebase } from "../Firebase";
import SingOutConfirm from "./singOutConfirm";

const SignOutMenuItem = ({ firebase }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  return (
    <>
      <MenuItem onClick={() => setOpen(true)}>
        <ListItemIcon>
          <PowerSettingsNew color={"primary"} />
        </ListItemIcon>
        <ListItemText>{t("logOut")}</ListItemText>
      </MenuItem>
      <SingOutConfirm open={open} close={handleClose} />
    </>
  );
};

export default withFirebase(SignOutMenuItem);
